import React, { type ReactNode } from 'react';

import styled from '@emotion/styled';

interface PingdomProps {
  id?: string;
  children?: ReactNode;
}

const PingdomContainer = styled.span({
  border: 0,
  clip: 'rect(1px, 1px, 1px, 1px)',
  height: 0,
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: 0,
});

const Pingdom: React.FC<PingdomProps> = ({ children, id }) => (
  <PingdomContainer aria-hidden="true" id={id}>
    {children ?? 'PINGDOM_CANARY_STRING'}
  </PingdomContainer>
);

export { Pingdom };
export default Pingdom;
